module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/633ef8c7dee9f3eb793a73f5ef867e19.png";